import React, { useState, useEffect } from 'react'
import { Button } from 'antd'
import { Moment } from '../../helpers'

export const JobDateTimeCalendar = ({ start, end, jobStatus }) => {
  const [fontcolor, setFontColor] = useState()

  useEffect(() => {
    switch (jobStatus) {
      case -2:
        setFontColor('red')
        break
      case -1:
        setFontColor('red')
        break
      case 1:
        setFontColor('#068a1a')
        break
      case 2:
        setFontColor('#068a8a')
        break
      case 3:
        setFontColor('#797a7a')
        break
    }
  })

  let showDay = ''
  let showTime = ''
  const _startTime = Moment(start)
  const _endTime = Moment(end)

  const dateStart = _startTime.format('YYYY-MM-DD')
  const dateEnd = _endTime.format('YYYY-MM-DD')
  if (dateStart == dateEnd) {
    showDay =  start && _startTime.isValid() ? _startTime.format('DD') : ''
    showTime = (start && _startTime.isValid() ? _startTime.format('LT')  : '') + (end && _endTime.isValid() ? ' - ' + _endTime.format('LT') : '');
  } else {
    showDay = (start && _startTime.isValid()  ? _startTime.format('DD') : '')+ (end && _endTime.isValid() ? ' - ' + _endTime.format('DD') : '')
    showTime = (start && _startTime.isValid() ? _startTime.format('LT') :'') + (end  && _endTime.isValid() ? ' - ' + _endTime.format('LT'): '')
  }

  return (
    <React.Fragment>
      <>
        <div
          align="left"
          style={{
            display: '',
            fontSize: 14,
            color: '#222222',
            backgroundColor: '#cccccc',
            textAlign: 'center',
            width: 100,
          }}
        >
          {showDay}
        </div>
        <div
          align="center"
          style={{
            display: '',
            fontSize: 12,
            width: 100,
            fontWeight:'normal',
            color: '#555555'
          }}
        >
          {showTime}
        </div>
      </>
    </React.Fragment>
  )
}
